/**
 * PageHeader — the canonical feature-page header.
 *
 * Standardises: optional back-link · icon · title · one-line subtitle ·
 * right-aligned actions. Matches the house style used by the feature pages
 * (a baseline row with a bottom border), so titles, subtitles and action
 * buttons sit in the same place on every page.
 *
 *   <PageHeader
 *     icon={Timer} iconClassName="text-rose-light" title="EXPLOITATION RACE"
 *     subtitle="velocity-first vuln triage"
 *     backTo="/app/zero-day-clock" backLabel="Zero Day Clock"
 *     actions={<button…/>} />
 */
import { Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { clsx } from 'clsx'

export default function PageHeader({
  icon: Icon,
  iconClassName = 'text-cyan',
  title,
  subtitle,
  backTo,
  backLabel,
  actions,
  className,
}: {
  icon?: React.ElementType
  iconClassName?: string
  title: React.ReactNode
  subtitle?: React.ReactNode
  backTo?: string
  backLabel?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}) {
  return (
    <div className={clsx('flex items-baseline gap-4 pb-2 border-b border-border flex-wrap', className)}>
      {backTo && (
        <Link to={backTo} className="text-text-muted hover:text-text-primary inline-flex items-center gap-1">
          <ChevronLeft size={14} /> {backLabel}
        </Link>
      )}
      <h1 className="text-lg font-bold text-text-primary flex items-center gap-2">
        {Icon && <Icon size={18} className={iconClassName} />} {title}
      </h1>
      {subtitle && <span className="text-[11px] text-text-muted">{subtitle}</span>}
      {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
    </div>
  )
}
